import { Component, ViewChild, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PbZonenData } from '../../../../providers/pbzonen-data';
import { UserData } from '../../../../providers/user-data';
import { MandantenData } from '../../../../providers/mandanten-data';
import { PbcatrulesComponent } from "../../../../components/pbcatrules/pbcatrules";
import { ToastController } from 'ionic-angular';
import { CommonData } from '../../../../providers/common-data';
import { CompletePPService } from '../../../../providers/epautocomplete-service';
import { ParplatzData } from '../../../../providers/pp-data';
import { ParkbewilligungenData } from '../../parkbewilligungen-data';

@Component({
  selector: 'page-pbzonen-edit',
  templateUrl: 'pbzonen-edit.html',
})
export class PbzonenEditPage {
  public pbzone: any;
  public bestellurl: string;
  public customertab = "zoneninfo";  
  public readonly: boolean = false;

  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public zonenData: PbZonenData
    , public userData: UserData
    , public mandantenData: MandantenData
    , public toastCtrl: ToastController
    , public common: CommonData
    , public zone: NgZone
    , public completePPService: CompletePPService
    , public ppData: ParplatzData
    , public pbData: ParkbewilligungenData
    ) {

    if(navParams.data.id>0){      
      this.zonenData.view(navParams.data.id).then(res => {
        //console.log(res);
        this.pbzone = res;
        this.initPP();
        //console.log(this.pbzone);
        this.updateBestellURL();    
        //this.oSelectedKategorieRegeln = res;
      });    
      
       
    }
    else{
      //-- New pbzonen ------
      this.pbzone = {name:""
                  , sichtbar:0
                  , archiviert:0
                  , bestellbar:1
                  , mandate_mandid: this.userData.mandate_mandid
                  , attributes : {
                      edited:"created",
                      grundstuecke:[],
                      periodcount:0,
                      addedpp: [],
                      removedpp: []
                  }
                  
                };
      this.updateBestellURL();
    }

  }

  initPP(){
    if(!this.pbzone.attributes.grundstuecke){
      this.pbzone.attributes.grundstuecke = [];      
    }
    this.pbzone.attributes.addedpp = [];
    this.pbzone.attributes.removedpp = [];
    this.readonly = (this.pbzone.archiviert == 1);

  }

  ionViewDidLoad() {
    //console.log(this.mandantenData.data);
  }

  validateInputs(){
    this.pbzone.name = this.pbzone.name.trim();  
    if (this.pbzone.name == ""){
      return -1;
    }
    if (!this.pbzone.mandate_mandid || this.pbzone.mandate_mandid<=0){
      return -2;
    }

    return 1;
  }

  pbzonenChange(event){
    //console.log(this.pbzone.edited);
    if(this.pbzone.attributes.edited != "created"){
      //console.log("changed");
      this.pbzone.attributes.edited = "changed";
    }
  }

  rulesChanged(event){
    //console.log("rulesChanged");
    this.pbzone.attributes.edited = "changed";    
  }  

  showError(text: string){
    let toast = this.toastCtrl.create({
      message: text,
      position: 'top',
      cssClass: 'toast-error',
      duration: 3000
    });
    toast.present();         
  }
  showMessage(text: string){
    this.showError(text);
  }

  updateChanges(){

    switch(this.validateInputs()){
      case -1: this.showError('Name darf nicht leer sein.');
               return;
      case -2: this.showError('Mandat darf nicht leer sein.');
               return;

    }
    if(this.pbzone.attributes.edited =="changed"){
      this.zonenData.update(this.pbzone).then(res => {
        //console.log(res);
        if(!res){
          this.showError("Fehler beim Speichern");
          return;
        }
        else{
          
          this.pbzone = res;     
          this.initPP();
          this.updateBestellURL();          
          this.showError("Speichern erfolgreich");
      }
      });       
    }
    else if(this.pbzone.attributes.edited =="created"){
      //console.log("create kat");
      //console.log(this.pbzone);
      
      this.zonenData.create(this.pbzone).then(res => {
        //console.log(res);
        if(!res){
          this.showError("Fehler beim Speichern");
          return;
        }
        else{
          this.pbzone = res;     
          this.updateBestellURL();
          this.initPP();
          this.showError("Zone erfolgreich gespeichert");


        }
      });      
    }
  }

  delete(){
    this.zonenData.delete(this.pbzone.id).then(res => {

      this.navCtrl.pop();
      //this.oSelectedKategorieRegeln = res;
    });    

  }

  discardChanges(){
    this.zonenData.view(this.pbzone.id).then(res => {
      this.pbzone = res;
      this.initPP();
      this.updateBestellURL();


      //this.oSelectedKategorieRegeln = res;
    });    

  
  }
  updateBestellURL(){
    if(this.pbzone && this.pbzone.attributes.edited != 'created'){
      this.bestellurl = '/bestellen2?z='+this.pbzone.id+'&m='+this.pbzone.mandate_mandid;
    }
    else{
      this.bestellurl = 'nach dem Speichern ersichtlich';
    }
  }

  removePP(ppindex){    
    this.pbzone.attributes.removedpp.push(this.pbzone.attributes.grundstuecke[ppindex]);
    this.pbzone.attributes.grundstuecke.splice(ppindex, 1);    
    this.evalPPChanged();

  }
  addPP( ppindex){
    //console.log(this.planingdata[epindex]);
    
    this.pbzone.attributes.grundstuecke.push(this.pbzone.attributes.removedpp[ppindex]);
    this.pbzone.attributes.removedpp.splice(ppindex, 1); 
    this.evalPPChanged();

    
  }
  newPPSelected(event){
    let bpppresent = false;
    this.pbzone.attributes.grundstuecke.forEach((g,index) => {
      if(g.grundid == event.grundid){
        bpppresent = true;
      }
    });
    this.pbzone.attributes.addedpp.forEach((g,index) => {
      if(g.grundid == event.grundid){
        bpppresent = true;
      }
    });

    if(bpppresent){
      let toast = this.toastCtrl.create({
        message: "Parkplatz bereits vorhanden",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });

      toast.present();         
    }
    else{
      this.pbzone.attributes.addedpp.push({grundid:event.grundid});

    }
    this.evalPPChanged();
  }  
  removeNewPP(ppindex){
    this.pbzone.attributes.addedpp.splice(ppindex, 1); 
    this.evalPPChanged();
  }


  evalPPChanged(){
    if(!this.pbzone.attributes.edited || this.pbzone.attributes.edited==""){
      if(this.pbzone.attributes.addedpp.length>0 || this.pbzone.attributes.removedpp.length>0 ){
        this.pbzone.attributes.edited="changed";
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbzonen/pbzonen-edit/pbzonen-edit.ts